import { Trans } from 'react-i18next';
import SemiconductorSection2Image1Poster from '../../assets/semiconductor_section2_image1.jpg';
import SemiconductorSection2Image1 from '../../assets/semiconductor_section2_image1.mp4';
import SemiconductorSection2Image2Poster from '../../assets/semiconductor_section2_image2.jpg';
import SemiconductorSection2Image2 from '../../assets/semiconductor_section2_image2.mp4';
import SemiconductorSection2Image3 from '../../assets/semiconductor_section2_image3.png';
import SemiconductorSection2Image4 from '../../assets/semiconductor_section2_image4.png';
import SemiconductorSection2Image7 from '../../assets/semiconductor_section2_image7.png';
import { CenterLayout, HorizontalEqualLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, Body4, H4, H7, Point2, Text4 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const SemiconductorFieldSection2 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(166)}`} />
      <CenterLayout>
        <H4 style={{ textAlign: 'center' }}><Trans i18nKey='초정밀 공정에 최적화된 반도체 설비를 통해, 안정성과 효율성을 동시에 갖춘 생산 환경을 제공합니다.' /></H4>
      </CenterLayout>
      <BTBox height={isMobile ? 24 : `${pxToRem(55)}`} />
      <CenterLayout>
        <Body1>
          <Trans i18nKey='비비테크는 반도체 라인에 필수적인 40~50여 종의 Gas Line 설계 및 시공 역량을 바탕으로, 삼성전자 우수 협력사로 선정되었으며, 미국 Texas Taylor 공장의 Hook-Up 파트너사로 참여하고 있습니다.' />
        </Body1>
      </CenterLayout>
      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />
      {isMobile ? (
        <video src={SemiconductorSection2Image1}
          autoPlay
          muted
          loop
          playsInline
          poster={SemiconductorSection2Image1Poster}
          style={{
            width: '100%', height: '400px', objectFit: 'cover',
            objectPosition: 'center',
          }} />
      ) : (
        <video src={SemiconductorSection2Image1}
          autoPlay
          muted
          loop
          playsInline
          poster={SemiconductorSection2Image1Poster}
          style={{ width: '100%' }} />
      )}
      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />
      <CenterLayout>
        <H4 style={{ textAlign: 'center',
          ...isEng ? {fontSize: pxToRem(50)} : {},
          ...isChina ? {wordBreak: 'break-word'} : {}
         }}><Trans i18nKey='비비테크는 반도체 산업의 정밀도와 안정성 요구에 부합하는 고도화된 설비 솔루션을 제공합니다.' /></H4>
      </CenterLayout>
      <BTBox height={isMobile ? 24 : `${pxToRem(55)}`} />
      <CenterLayout>
        <Body1>
          <Trans i18nKey='설계부터 제작, 설치, 유지보수까지 유틸리티 전 공정을 아우르는 Total Service Provider로서, 생산 효율을 극대화하고 불량률을 제로화하며, 변화하는 시장 환경에도 유연하게 대응합니다.' />
        </Body1>
      </CenterLayout>
      <BTBox height={isMobile ? 60 : `${pxToRem(141)}`} />
      {isMobile ? (
        <img src={SemiconductorSection2Image7} style={{
          width: '100%', height: '400px', objectFit: 'cover',
          objectPosition: '60% center',
        }} />
      ) : (
        <img src={SemiconductorSection2Image7} style={{ width: '100%' }} />
      )}
      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />
      <CenterLayout>
        <H7>
          <Trans i18nKey='B·Link Auto Bending System은 자체 개발한 Auto Bending Machine Compiler 프로그램과 자동화 설비를 통해 혁신적인 밴딩 기술을 구현하는 지능형 플랫폼입니다. 3D 설계 데이터와 연동되어, 도면부터 제품까지 종이 없는 자동화 공정을 실현합니다.' />
        </H7>
      </CenterLayout>

      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />

      {isMobile ? (
        <VerticalLayout>
          <video src={SemiconductorSection2Image2}
            autoPlay
            muted
            loop
            playsInline
            poster={SemiconductorSection2Image2Poster}
            style={{ width: isMobile ? '100%' : '55%' }} />
          <BTBox height={16} />
          <Point2>Auto Bending Machine Compiler</Point2>
          <BTBox height={16} />
          <div style={{width: '100%', height: '0.5px', backgroundColor: 'black', opacity: 0.4}}></div>
          <BTBox height={30} />
          <VerticalLayout style={{ flex: 1 }}>
            <H7 style={{ lineHeight: `${pxToRem(50)}` }}><Trans i18nKey='튜브의 절단, 가공, 밴딩까지 전 공정의 자동화로 작업시간을 단축하고 효율성을 극대화합니다.' /></H7>
            <BTBox height={16} />
            <Text4 style={{ color: '#808080' }}><Trans i18nKey='핵심 기능' /></Text4>
            <HorizontalLayout>
              <Text4 style={{ color: '#808080' }}>·</Text4><BTBox width={14} />
              <Text4 style={{ color: '#808080' }}><Trans i18nKey='설계 도면을 오토밴딩용 파일로 자동 변환하고, 배관 및 설비 간 간섭을 자동으로 검사' /></Text4>
            </HorizontalLayout>
            <HorizontalLayout>
              <Text4 style={{ color: '#808080' }}>·</Text4><BTBox width={10} />
              <Text4 style={{ color: '#808080' }}><Trans i18nKey='자동 커팅 플랜 및 BOM 산출로 자재 Loss 최소화' /></Text4>
            </HorizontalLayout>
            <HorizontalLayout>
              <Text4 style={{ color: '#808080' }}>·</Text4><BTBox width={10} />
              <Text4 style={{ color: '#808080' }}><Trans i18nKey='사전 시뮬레이션으로 작업 오류 예방 및 최적 환경 확보' /></Text4>
            </HorizontalLayout>
            <HorizontalLayout>
              <Text4 style={{ color: '#808080' }}>·</Text4><BTBox width={11} />
              <Text4 style={{ color: '#808080' }}><Trans i18nKey='QR코드 레이저 각인을 통한 제품 이력 추적 및 품질 관리 체계화' /></Text4>
            </HorizontalLayout>
          </VerticalLayout>
        </VerticalLayout>
      ) : (
        <HorizontalLayout>
          <VerticalLayout style={{ width: '50%' }}>
            <Body4 style={{ lineHeight: `${pxToRem(50)}` }}><Trans i18nKey='튜브의 절단, 가공, 밴딩까지 전 공정의 자동화로 작업시간을 단축하고 효율성을 극대화합니다.' /></Body4>
            <BTBox height={pxToRem(77)} />
            <Text4 style={{ color: '#808080' }}><Trans i18nKey='핵심 기능' /></Text4>
            <HorizontalLayout>
              <Text4 style={{ color: '#808080' }}>·</Text4><BTBox width={10} />
              <Text4 style={{ color: '#808080' }}><Trans i18nKey='설계 도면을 오토밴딩용 파일로 자동 변환하고, 배관 및 설비 간 간섭을 자동으로 검사' /></Text4>
            </HorizontalLayout>
            <HorizontalLayout>
              <Text4 style={{ color: '#808080' }}>·</Text4><BTBox width={10} />
              <Text4 style={{ color: '#808080' }}><Trans i18nKey='자동 커팅 플랜 및 BOM 산출로 자재 Loss 최소화' /></Text4>
            </HorizontalLayout>
            <HorizontalLayout>
              <Text4 style={{ color: '#808080' }}>·</Text4><BTBox width={10} />
              <Text4 style={{ color: '#808080' }}><Trans i18nKey='사전 시뮬레이션으로 작업 오류 예방 및 최적 환경 확보' /></Text4>
            </HorizontalLayout>
            <HorizontalLayout>
              <Text4 style={{ color: '#808080' }}>·</Text4><BTBox width={10} />
              <Text4 style={{ color: '#808080' }}><Trans i18nKey='QR코드 레이저 각인을 통한 제품 이력 추적 및 품질 관리 체계화' /></Text4>
            </HorizontalLayout>
          </VerticalLayout>
          <BTBox width={40} />
          <VerticalLayout style={{ width: '50%' }}>
            <video src={SemiconductorSection2Image2}
              autoPlay
              muted
              loop
              playsInline
              poster={SemiconductorSection2Image2Poster}
              style={{ width: '100%' }} />
            <BTBox height={pxToRem(33)} />
            <Point2>
              Auto Bending Machine Compiler
            </Point2>
          </VerticalLayout>
        </HorizontalLayout>
      )}
      <BTBox height={isMobile ? 30 : pxToRem(100)} />

      <HorizontalEqualLayout gap={isMobile ? '30px' : pxToRem(38)} style={{ alignItems: 'start', flexDirection: isMobile ? 'column' : 'row', }}>
        <VerticalLayout>
          <img src={SemiconductorSection2Image3} style={{ width: '100%' }} />
          <BTBox height={isMobile ? 16 : 33} />
          <Point2>
            Auto Bending Machine
          </Point2>
          {isMobile && (
            <>
              <BTBox height={16} />
              <div style={{ width: '100%', height: '0.5px', backgroundColor: '#000000', opacity: 0.4 }}></div>
            </>
          )}
        </VerticalLayout>
        <VerticalLayout>
          <img src={SemiconductorSection2Image4} style={{ width: '100%' }} />
          <BTBox height={isMobile ? 16 : 33} />
          <Point2>
            Auto Cutting Machine
          </Point2>
        </VerticalLayout>
      </HorizontalEqualLayout>
      <BTBox height={pxToRem(205)} />
    </VerticalLayout>
  );
};

export default SemiconductorFieldSection2;
